import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

var _actions;

/*
 * @Author: Jhonsem
 * @Date: 2018-10-25 20:33:27
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-06-06 17:03:55
 */
import * as types from "@/store/constants/types";
import { getLang } from "@/api/utils/apiHelper";
import { loadLanguageAsync } from "@/i18n/i18n-setup";
/**
 *  router push 首屏登录后的页面跳转逻辑
 */

var actions = (_actions = {}, _defineProperty(_actions, types.INITIAL_SETTING, function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref) {
    var state, commit, dispatch, rootState, getters;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch, rootState = _ref.rootState, getters = _ref.getters;
            _context.prev = 1;
            //init iap：
            //拉取product_id的左右信息，用来显示本地化价格:
            dispatch(types.INIT_IAP); //初始化api

            dispatch(types.AWS_INIT); //初始化aws

            dispatch(types.INITIAL_LANGUAGE); //初始化语言
            // 拉取setting:

            _context.next = 7;
            return dispatch(types.REQUEST_SETTING_DATA);

          case 7:
            // 拉取所有订阅
            dispatch(types.UPDATE_SERVICE_LIST); //拉取product_id的左右信息, IOS购买前必须拉取一遍

            dispatch(types.REGISTER_PRODUCT_ID).catch(function (error) {});
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.log("INITIAL_SETTING Error:", _context.t0);
            return _context.abrupt("return", _Promise.reject(_context.t0));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.INITIAL_LANGUAGE, function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(_ref3) {
    var state, commit, dispatch, rootState, getters, lang, loadLanguageAsyncResult;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = _ref3.state, commit = _ref3.commit, dispatch = _ref3.dispatch, rootState = _ref3.rootState, getters = _ref3.getters;
            _context2.prev = 1;
            lang = getLang();
            _context2.next = 5;
            return loadLanguageAsync(lang);

          case 5:
            loadLanguageAsyncResult = _context2.sent;
            _context2.next = 10;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));

  return function (_x2) {
    return _ref4.apply(this, arguments);
  };
}()), _actions);
export default actions;